export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** Format "YYYY-MM" to short month name */
export function formatMonth(month: string): string {
  const parts = month.split("-");
  if (parts.length >= 2) {
    return MONTH_NAMES[parseInt(parts[1], 10) - 1] || parts[1];
  }
  return month;
}

/** Format a number as compact currency: $1.2M / $45K / $1,234 */
export function formatCurrency(value: number): string {
  if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `$${Math.round(value / 1000)}K`;
  }
  return `$${value.toLocaleString("en-US")}`;
}

/** Format a number compactly without currency prefix: 1.2M / 45K / 1234 */
export function formatCompactNumber(value: number): string {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${Math.round(value / 1000)}K`;
  }
  return value.toString();
}

/** Format a date string as short date: "Mar 15" */
export function formatShortDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
  });
}

export { default as StatCard } from "./StatCard";
export { default as RevenueChart } from "./RevenueChart";
export { default as OrdersChart } from "./OrdersChart";
export { default as FunnelChart } from "./FunnelChart";
export { default as DestinationPieChart } from "./DestinationPieChart";
export { default as OccupancyTable } from "./OccupancyTable";
export { default as GuideStats } from "./GuideStats";
export { default as CustomerStats } from "./CustomerStats";
export { default as MarketingStats } from "./MarketingStats";
export { default as TrafficChart } from "./TrafficChart";
export { default as AdsPerformance } from "./AdsPerformance";
